// The note undo stack (22 Oct 2026). historyIndex counts the steps currently applied: entries before it can be
// undone, entries from it on are undone steps waiting for Redo. A new step drops every undone step first.

export function pushStep(history, historyIndex, step) {
    const kept = history.slice(0, historyIndex);
    kept.push(step);
    return { history: kept, historyIndex: kept.length };
}

export function canUndo(history, historyIndex) {
    return historyIndex > 0 && historyIndex <= history.length;
}

export function canRedo(history, historyIndex) {
    return historyIndex >= 0 && historyIndex < history.length;
}


// WEBPACK FOOTER //
// ./src/lib/note-history.js